import script from "./PanelPerfilDesplegable.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelPerfilDesplegable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__